import type { KeyCombo, ShortcutPlatform } from '../types';
import { parseKeyCombo } from './keyCombo';

/**
 * platform 差分の一元化。
 * 散在していた navigator.userAgent.includes('Mac') 直書きの置き換え先（§2.4）。
 */
function isMac(): boolean {
  return typeof navigator !== 'undefined' && navigator.userAgent.includes('Mac');
}
export function currentPlatform(): ShortcutPlatform {
  return isMac() ? 'mac' : 'win';
}
const MAC_MODIFIER_SYMBOLS = {
  ctrl: '⌃',
  alt: '⌥',
  shift: '⇧',
  meta: '⌘'
} as const;
const WIN_MODIFIER_LABELS = {
  ctrl: 'Ctrl',
  alt: 'Alt',
  shift: 'Shift',
  meta: 'Win'
} as const;
const SPECIAL_KEY_LABELS: Record<string, string> = {
  arrowdown: '↓',
  arrowleft: '←',
  arrowright: '→',
  arrowup: '↑',
  backspace: '⌫',
  enter: '↵',
  escape: 'Esc',
  space: 'Space',
  tab: 'Tab'
};
function formatKeyToken(key: string): string {
  const special = SPECIAL_KEY_LABELS[key];
  if (special) return special;
  return key.length === 1 ? key.toUpperCase() : key;
}

/**
 * 表示用ラベル整形。mac は記号連結（⌘K）、win は '+' 連結（Ctrl+K）。
 * modifier の表示順は macOS 慣例（⌃⌥⇧⌘）/ Windows 慣例（Ctrl+Alt+Shift）。
 */
export function formatKeyLabel(combo: KeyCombo, platform: ShortcutPlatform): string {
  const parsed = parseKeyCombo(combo);
  const keyLabel = formatKeyToken(parsed.key);
  if (platform === 'mac') {
    return [parsed.ctrl ? MAC_MODIFIER_SYMBOLS.ctrl : '', parsed.alt ? MAC_MODIFIER_SYMBOLS.alt : '', parsed.shift ? MAC_MODIFIER_SYMBOLS.shift : '', parsed.meta ? MAC_MODIFIER_SYMBOLS.meta : '', keyLabel].join('');
  }
  return [parsed.ctrl ? WIN_MODIFIER_LABELS.ctrl : '', parsed.alt ? WIN_MODIFIER_LABELS.alt : '', parsed.shift ? WIN_MODIFIER_LABELS.shift : '', parsed.meta ? WIN_MODIFIER_LABELS.meta : '', keyLabel].filter(part => part !== '').join('+');
}